var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapCamelKeysToSnakeKeysRecursively } from '../../utils/case-conversion';
import { createQueryParams } from '../shared/queryParams';
import { requestGet } from './fetch';
import * as utils from './utils';
export var requestGetSearch = utils.memoize(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var mode = args[0], linkToken = args[1], query = args[2], platformType = args[3], responseTypes = args[4], filterSpecifiedEmployersListType = args[5], queryParams = args[6];
    var stringParams = createQueryParams(__assign(__assign({ q: encodeURIComponent(query), platform_type: platformType, response_types: responseTypes, filter_specified_employers_list_type: filterSpecifiedEmployersListType }, mapCamelKeysToSnakeKeysRecursively(queryParams)), { enable_fuzzy_search: true }));
    return requestGet(mode, "/v1/ui/search?".concat(stringParams), utils.getLinkAuth(linkToken));
});
export var requestGetPlatforms = utils.memoize(function (mode, linkToken, platformType) {
    return requestGet(mode, "/v1/ui/platforms?platform_filter=exclude_esps".concat(platformType ? "&type=".concat(platformType) : ''), utils.getLinkAuth(linkToken));
});
export var requestGetEmployers = utils.memoize(function (mode, linkToken, tags, searchText) {
    // Initialize URLSearchParams
    var params = new URLSearchParams();
    // Append tags if they exist
    if (tags) {
        // Assuming tags is an array of string, append each tag individually
        tags.forEach(function (tag) { return params.append('tags', tag); });
    }
    // Append searchText if it exists
    if (searchText) {
        params.append('q', searchText); // Use 'q' for the searchText parameter
    }
    // Construct the URL with query parameters
    var url = "/v1/ui/employers/search?".concat(params.toString());
    return requestGet(mode, url, utils.getLinkAuth(linkToken));
});
